import * as backend from 'backend-helpers/memberWallMaterials';
import * as member_backend from 'backend-helpers/member';

import {
    MEMBER_WALL_POST_DELETE_REQUEST,
    MEMBER_WALL_POST_DELETE_SUCCESS,
    MEMBER_WALL_POST_DELETE_ERROR
} from './member';

const GET_MEMBER_WALL_MATERIALS_REQUEST = 'GET_MEMBER_WALL_MATERIALS_REQUEST';
const GET_MEMBER_WALL_MATERIALS_SUCCESS = 'GET_MEMBER_WALL_MATERIALS_SUCCESS';
const GET_MEMBER_WALL_MATERIALS_FAILURE = 'GET_MEMBER_WALL_MATERIALS_FAILURE';

const initState = {
    list: []
};

export default function memberWallMaterials(state = initState, action) {
    if (action.type == GET_MEMBER_WALL_MATERIALS_SUCCESS) {
        let {wallMaterials, ...rest} = action.result.data;

        return {
            ...state,
            list: wallMaterials
        }
    }

    if (action.type === MEMBER_WALL_POST_DELETE_SUCCESS) {
        let new_list = state.list.filter((item) => item.id !== action.id),
            is_update_needed = (state.list.length > 0 && new_list.length != state.list.length);

        if (is_update_needed) {
            return {
                ...state,
                list: new_list
            }
        }
    }

    return state;
}

export function getMemberWallMaterials() {
    return {
        types: [GET_MEMBER_WALL_MATERIALS_REQUEST, GET_MEMBER_WALL_MATERIALS_SUCCESS, GET_MEMBER_WALL_MATERIALS_FAILURE],
        promise: backend.getMemberWallMaterials()
    }
}

export function memberDeleteWallPost(id) {
    return {
        types: [MEMBER_WALL_POST_DELETE_REQUEST, MEMBER_WALL_POST_DELETE_SUCCESS, MEMBER_WALL_POST_DELETE_ERROR],
        promise: member_backend.deleteWallPost({id:id}),
        id
    }
}





// WEBPACK FOOTER //
// ./src/reducers/memberWallMaterials.js